export const setFocusOnlyOnActiveSlides = (): void => {
  Array.from(document.getElementsByClassName('slick-slide')).forEach((element) =>{
    if(element.classList.contains('slick-active')){
      Array.from(element.getElementsByClassName('link')).forEach((link)=>{
        link.setAttribute('tabindex', '0');
      });
    }else{
      Array.from(element.getElementsByClassName('link')).forEach((link)=>{
        link.setAttribute('tabindex', '-1');
      });
    }
  }
  );
};

export const setSlickArrowDisabled = (): void => {
  const disabledButton = document.getElementsByClassName('slick-arrow slick-disabled')[0];
  if (disabledButton) {
    disabledButton.setAttribute('disabled', 'disabled');
  }
};

export const setSlickArrowEnabled = (): void => {
  const disabledButton = document.getElementsByClassName('slick-arrow slick-disabled')[0];
  if (disabledButton) {
    disabledButton.removeAttribute('disabled');
  }
}
